import { QCNamingConvention } from './qc-naming-convention';

export class QCDomesticOnlyNamingConvention extends QCNamingConvention {

  get description(): string {
    return "Domestic Only";
  }

  get generatedName(): string {
    let name = this.houseNumber + '_' + this.programTitle + this.domesticEpisode;
    if (this.revision != null) {
      name += '_R' + this.revision
    }
    name += '_' + this.status + '_QC';
    return name;
  }

  static get requiredComponents(): string[] {
    return [
      'domesticEpisode',
      'houseNumber',
      'programTitle',
      'status'
    ];
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc-naming-conventions/qc-domestic-only-naming-convention.ts